import { NavLink, Link } from "react-router-dom";
import './Style.css';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import ExploreIcon from '@mui/icons-material/Explore';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AddBoxIcon from '@mui/icons-material/AddBox';
// import tiktakaLogo from '../../assets/tiktakaLogo.png';
import tiktakaLogo from '../../assets/tiktakaLogo2.png';
import LoginIcon from '@mui/icons-material/Login';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import NotificationPanel from "../modals/NotificationPanel";
import SearchPanel from "../modals/SearchPanel";

import CreatePostPanel from "../modals/CreatePostPanel";
import AllPopups from "./AllPopups"; 

const Sidebar = () => {
  const { token, user,setShowLogin,showLogin } = useContext(AppContext);

  const [showNotification, setShowNotification] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showCreatePost, setShowCreatePost] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notifCount, setNotifCount] = useState(0);

  useEffect(() => {
    if (collapsed) {
      document.body.classList.add('sidebar-collapsed');
    } else {
      document.body.classList.remove('sidebar-collapsed');
    }
  }, [collapsed]);

    useEffect(() => {
    fetchNotifications();

    //  const interval = setInterval(fetchNotifications, 60000);
    // return () => clearInterval(interval);
    
  }, []);



  const fetchNotifications = async () => {
    const res = await fetch('https://dashboard.tiktaka.com/api/notifications', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.ok) {
      const data = await res.json();
      setNotifications(data.notifications);
      setNotifCount(data.notifications.length);

      console.log('notifications');
      console.log(data.notifications.length);

    }

  };

    const closeAllModals = () => {
      setShowSearch(false);
      setShowNotification(false);
      setShowCreatePost(false);
      setCollapsed(false);
  };
  

  const handleOpenPanels = (e) => {
    closeAllModals();
    e.preventDefault();
    setCollapsed(!collapsed);
  };

  return (
    <div className={`leftSideHome ${collapsed ? "collapsed" : ""}`}>
      <div className='leftSidePart'>
        <div className='logoPart'>
          <Link to='/home'><img className='LogoImg' src={tiktakaLogo} alt='tiktaka logo' /></Link>
        </div>

        <div className='navLinkPart'>
          <NavLink to='/home'>
            <div className='navLink'>
              <HomeIcon sx={{ fontSize: '30px', margin: '0 20px 0 0' }} />
              <div>Home</div>
            </div>
          </NavLink>

          <NavLink className='notActive' to="#" onClick={(e) => {
            handleOpenPanels(e);
            setShowSearch(!showSearch);
          }}>
            <div className='navLink'>
              <SearchIcon sx={{ fontSize: '30px', margin: '0 20px 0 0' }} />
              <div>Search</div>
            </div>
          </NavLink>
          {showSearch && <SearchPanel onClose={closeAllModals} />}

          <NavLink to='/explore' >
            <div className='navLink'>
              <ExploreIcon sx={{ fontSize: '30px', margin: '0 20px 0 0' }} />
              <div>Explore</div>
            </div>
          </NavLink>

          <NavLink to='/reels'>
            <div className='navLink'>
              <PlayArrowIcon sx={{ fontSize: '30px', margin: '0 20px 0 0' }} />
              <div>Reels</div>
            </div>
          </NavLink>

          <NavLink className='notActive' to="#" onClick={(e) => {
            handleOpenPanels(e);
            setShowNotification(!showNotification);
          }}>
            <div className='navLink'>

                {notifCount > 0 && (
                  <span className="notifBadge">{notifCount}</span>
                )}

              <NotificationsIcon sx={{ fontSize: '30px', margin: '0 20px 0 0' }} />
              <div>Notifications</div>
            </div>
          </NavLink>
          {showNotification && <NotificationPanel onClose={closeAllModals} notifications={notifications} />}


            <AllPopups />

          {/* {showRegister && (
            <RegisterPop
              onClose={closeAllModals}
              onSwitchToLogin={() => {
                setShowRegister(false);
                setShowLogin(true);
              }}
            />
          )} */}

          <NavLink className='notActive' to="#" onClick={(e) => {
            handleOpenPanels(e);
            setShowCreatePost(!showCreatePost);
          }}>
            <div className='navLink'>
              <AddBoxIcon sx={{ fontSize: '30px', margin: '0 20px 0 0' }} />
              <div>Create</div>
            </div>
          </NavLink>

          {showCreatePost && <CreatePostPanel onClose={closeAllModals} />}

          {!user ? (
            <NavLink className='notActive' to="#" onClick={(e) => {
              e.preventDefault();
              setShowLogin(!showLogin);
            }}>
              <div className='navLink'>
                <LoginIcon sx={{ fontSize: '30px', margin: '0 20px 0 0' }} />
                <div>Login</div>
              </div>
            </NavLink>
          ) : (
            <NavLink to={`/profile/${user?.hashed_id}/${user?.username}`}>
              <div className={`navLink ${window.location.pathname === `/profile/${user?.hashed_id}` ? "active" : undefined}`}>
                <AccountCircleRoundedIcon sx={{ fontSize: '30px', margin: '0 20px 0 0' }} />
                <div>Profile</div>
              </div>
            </NavLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
